import { __assign, __read } from "tslib";
import React, { useState, useRef, useCallback } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Icon } from '@keen.io/icons';
import { colors } from '@keen.io/colors';
import { Container, SettingsContainer, MotionChartSettings, } from './widget-item.styles';
import { HIDE_TIME } from './constants';
var settingsMotion = {
    initial: { transform: "translateX(calc(100% + 15px))", opacity: 0 },
    animate: { transform: "translateX(calc(100% + 3px))", opacity: 1 },
    exit: { transform: "translateX(calc(100% + 30px))", opacity: 0 },
};
var WidgetItem = function (_a) {
    var icon = _a.icon, onClick = _a.onClick, isActive = _a.isActive, hasOptions = _a.hasOptions, children = _a.children;
    var _b = __read(useState(false), 2), settingsVisible = _b[0], setSettingsVisibility = _b[1];
    var hideTrigger = useRef(null);
    var hideSettings = useCallback(function () {
        if (hideTrigger.current)
            clearTimeout(hideTrigger.current);
        hideTrigger.current = setTimeout(function () {
            setSettingsVisibility(false);
        }, HIDE_TIME);
    }, []);
    var showSettings = useCallback(function () {
        if (hideTrigger.current)
            clearTimeout(hideTrigger.current);
        setSettingsVisibility(true);
    }, []);
    return (React.createElement(Container, { "data-testid": "widget-item", isActive: isActive || settingsVisible, onClick: function (e) { return !isActive && onClick(e); } },
        React.createElement(Icon, { width: 18, height: 18, type: icon, fill: colors.blue[500] }),
        hasOptions && (React.createElement(SettingsContainer, { "data-testid": "settings-tick", onMouseEnter: function () { return showSettings(); }, onMouseLeave: function () { return hideSettings(); } },
            React.createElement(Icon, { width: 10, height: 15, type: "corner-tick", fill: colors.lightBlue[500] }))),
        React.createElement(AnimatePresence, null, settingsVisible && (React.createElement(MotionChartSettings, __assign({}, settingsMotion, { onMouseEnter: function () { return showSettings(); }, onMouseLeave: function () { return hideSettings(); } }), children)))));
};
export default WidgetItem;
